import { Delete, Edit } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  breakStringIntoLines,
  getNewParameters,
  getObjectSubset,
  getParameters,
} from '../../lib/helper';
import { keywordItemsSelector } from '../../redux/keyword';
import {
  getSimilarImagesKeywordListing,
  deleteSimilarImageKeyword,
} from '../../Services/keywordsApis';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import AddSimilarImageKeyword from '../Modals/AddSimilarImageKeyword';
import ConfirmationModal from '../Modals/ConfirmationModal';
import EditSimilarImageKeyword from '../Modals/EditSimilarImageKeyword';
import MatTable from '../Tables/MatTable';
import LinkHiddenKeyword from '../Modals/LinkHiddenKeyword';
import {
  action,
  logsMessagesList,
  modulesNames,
} from '../../data/logsMessages';
import { adminAddLogs } from '../../Services/commonService';

const limit = 10;
const column = [
  {
    label: 'SNO',
    id: 'sno',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData || 'N/A'}
      </span>
    ),
  },
  {
    label: 'ID',
    id: 'visible_keyword_id',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData}
      </span>
    ),
  },
  {
    label: 'Visible Keyword',
    id: 'visible_keyword',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData ? breakStringIntoLines(columnData, 20) : 'N/A'}
      </span>
    ),
  },
];

function SimilarImagesKeywordsList() {
  const [tableListing, setTableListing] = useState([]);
  const [page, setPage] = useState(1);
  const [allParams, setAllParams] = useState(getParameters());
  const { similarImageKeywordList } = useSelector(keywordItemsSelector);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openLinkKeyword, setOpenLinkKeyword] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [keywordsForId, setHiddenKeywordsForId] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const getListing = async (params = {}) => {
    const payload = {
      page: String(1),
      limit: limit,
      // order_status: String(1),
      ...allParams,
      ...params,
    };
    dispatch(getSimilarImagesKeywordListing(payload));
    setPage(Number(payload.page));
  };

  useEffect(() => {
    getListing();
  }, []);

  useEffect(() => {
    let params = getParameters();
    setAllParams(params);
  }, [location?.search]);

  useEffect(() => {
    let data = getNewParameters(allParams);
    if (data?.search !== location.search) {
      navigate(data.newUrl, { replace: false });
      if (data?.parameters?.page) {
        setPage(Number(data?.parameters?.page));
      }
    }
    getListing();
  }, [allParams]);

  //making data format for table input
  useEffect(() => {
    if (similarImageKeywordList?.items?.data?.length >= 0) {
      setTableListing(similarImageKeywordList?.items?.data);
    }
  }, [similarImageKeywordList.items]);

  const handleCofirmModalOpen = (value) => {
    setConfirmDelete(value);
  };

  const actionBody = (data) => {
    return (
      <>
        <div style={{ display: 'flex' }}>
          <CustomButton
            toolTipTittle={'Edit Similar Image Keyword'}
            onClick={() => {
              handleEdit(true, data);
            }}
            className="buttonDense noMinWidth"
            sx={{
              bgcolor: 'buttonPrimary.main',
              color: 'buttonPrimary.contrastText',
            }}
          >
            <Edit />
          </CustomButton>
          <CustomButton
            toolTipTittle={'Delete Similar Image Keyword'}
            onClick={() => {
              handleCofirmModalOpen(true);
              setDeleteData(data);
            }}
            className="buttonDense noMinWidth"
            sx={{
              bgcolor: 'buttonDanger.main',
              color: 'buttonDanger.contrastText',
            }}
          >
            <Delete />
          </CustomButton>
        </div>
      </>
    );
  };

  const handleAdd = (value) => {
    setOpen(value);
  };

  const handleLinkKeyword = (value, data = {}) => {
    setOpenLinkKeyword(value);
    setSelectedData(data);
    if (!value) {
      setSelectedData(null);
    }
  };

  //   const handleVisibleCsvUpload = (value) => {
  //     setOpenVisibleUpload(value);
  //   }

  const handleEdit = (value, data = {}) => {
    setEditOpen(value);
    setSelectedData(data);
  };

  const handleConfirmDelete = async (value) => {
    if (value && deleteData) {
      const resp = await deleteSimilarImageKeyword({
        similarimage_keyword_id: deleteData?.sno,
      });
      if (resp) {
        let payloadForLogs = {
          action: action?.delete,
          module: modulesNames?.keywords,
          description: logsMessagesList?.keyword?.keywordSimilarImageDelete,
        };
        await adminAddLogs(payloadForLogs);
        getListing({ page: '1' });
        setPage(1);
        setDeleteData(null);
      }
    } else {
      setDeleteData(null);
    }
  };

  return (
    <>
      <MatTable
        loading={similarImageKeywordList?.loading}
        showCheckbox={false}
        columns={column}
        data={tableListing}
        onApplyFilter={(data = {}) => {
          getListing({
            page: String(1),
            start_date: '',
            end_date: '',
            ...getObjectSubset(data, 'start_date', 'end_date'),
          });
          if (Object.keys(data).length > 0) {
            setAllParams({
              ...allParams,
              page: String(1),
              ...getObjectSubset(data, 'start_date', 'end_date'),
            });
          } else {
            setAllParams({
              page: String(1),
            });
          }
        }}
        action={actionBody}
        page={page}
        perPage={limit}
        total={similarImageKeywordList?.items?.totalCount || 0}
        setPage={setPage}
        handleSearch={(searchTerm) => {
          getListing({
            page: String(1),
            search: searchTerm,
          });
          setAllParams({
            ...allParams,
            page: String(1),
            search: searchTerm,
          });
        }}
        handlePageChange={(newPage) => {
          getListing({
            page: String(newPage),
          });
          setAllParams({
            ...allParams,
            page: String(newPage),
          });
        }}
        toolbarEnable={true}
        toolBarButton={() => {
          return (
            <>
              {/* <CustomButton onClick={()=>{handleVisibleCsvUpload(true)}} color={'buttonPrimary'} 
              sx={(theme)=>({ padding: '10px 10px', marginRight: 1, 
                [theme.breakpoints.down("md")]: {
                  flex: 1,
                }
              })}>Upload CSV</CustomButton> */}
              <CustomButton
                onClick={() => {
                  handleAdd(true);
                }}
                color={'buttonPrimary'}
                sx={(theme) => ({
                  padding: '10px 10px',
                  marginRight: 1,
                  [theme.breakpoints.down('md')]: {
                    flex: 1,
                  },
                })}
              >
                Add Similar Image Keyword
              </CustomButton>
            </>
          );
        }}
        pagination={true}
        filtersUrlData={allParams || {}}
      />
      {open && (
        <AddSimilarImageKeyword
          open={open}
          handleOpen={handleAdd}
          setPage={setPage}
          getListing={getListing}
        />
      )}
      {editOpen && (
        <EditSimilarImageKeyword
          open={editOpen}
          handleOpen={handleEdit}
          setPage={setPage}
          getListing={getListing}
          selectedData={selectedData}
        />
      )}
      {confirmDelete && (
        <ConfirmationModal
          open={confirmDelete}
          handleConfirm={handleConfirmDelete}
          setOpen={handleCofirmModalOpen}
        />
      )}
      {openLinkKeyword && (
        <LinkHiddenKeyword
          open={openLinkKeyword}
          handleOpen={handleLinkKeyword}
          setPage={setPage}
          getListing={getListing}
          vid={selectedData?.vid}
          keywordsForId={keywordsForId}
        />
      )}
    </>
  );
}

export default SimilarImagesKeywordsList;
